
export const bat_capacity = 10000;
export const heat_sink_transfer = 750;
export const radiator_base_dissipation = 1500;
